import "bootstrap/js/tooltip";

export default {
    apply($context) {
        $context.find("[data-toggle=\"tooltip\"]").tooltip();
    },
    destroy($context) {
        $context.find("[data-toggle=\"tooltip\"]").tooltip("destroy");
    }
};